'use strict';

import SliderComponent from "../../../_imports/shared/slider.common.js";
import {debouncer} from "../../../_imports/utils/utils.common.js";
import initLazyLoad from "../../../../components/lazyLoad.js";
import ThumbnailVideoLoop from "../../resource-banner/_imports/video-loop.common.js";

const offset = 154;
const resourceVideoSliderOptions = {
    perView: 4,
    peek : {
        before: offset,
        after: (offset + 20),
    },
    breakpoints: {
        679: {
            gap: 16,
            perView: 1,
            peek : {
                before: 0,
                after: offset,
            }
        },
        1024: {
            gap: 24,
            perView: 2,
            peek : {
                before: 0,
                after: (offset / 3),
            }
        }
    }
};

export default {
    comments: true,
    mixins: [
        SliderComponent,
        ThumbnailVideoLoop
    ],
    data(){
        return {
            overwriteSliderMediumCardsOptions: resourceVideoSliderOptions,
            lastIndex: 0
        }
    },
    methods: {
        initForDesktop() {
            return window.innerWidth > 1024;
        },
       
        resetPosition() {
            /*
            * Fixed the issue when the slider is not "active" on desktop, but is active on mobile/tablet
            * Reference: WEBR-8424
             */

            if(this.$refs.carousel?.dataset?.isSlider === 'true') {
                this.carousel.enable().go('<<');
            }
        },
        runStart() {
            this.carousel.on('run.start', () => {
                if(this.isNavHidden) {
                    setTimeout(() => {
                        this.carousel.disable();
                    }, 0);
                }
            });
        },
        sliderMountAfter() {
            initLazyLoad({
                isInitFromVueComponent: true,
                componentName: 'resource-video-banner'
            });
        },
        scrollToSlide() {
            const watchingLabel = this.$refs.watchingLabel;
            const isSlider = this.$refs.carousel?.dataset?.isSlider === 'true';

            if(watchingLabel) {
                const slideIndex = watchingLabel.closest('[data-slide-index]')?.dataset?.slideIndex;

                if(isSlider && slideIndex) {
                    this.carousel.go(`=${slideIndex}`);
                }
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$el.classList.add('component-is-mounted');

            setTimeout(() => {
                this.$root.$on("slider.mount.after", this.sliderMountAfter());

                if(this.$refs.carousel?.dataset?.isSlider === 'false') {
                    this.carousel.destroy();
                }

                if(this?.carousel) {
                    this.hoverVideo();
                    if(this.initForDesktop()) {
                        this.setVideoSrc();
                    }
                    this.runStart();
                    this.scrollToSlide();
                }

                window.addEventListener('resize', debouncer(() => {
                    this.setVideoSrc();
                }, 250));
            }, 150);
        });
    }
};